import {scorePill} from '../../layouts/theme/designSystem';

export const SCORE_STAT_HIGH_THRESHOLD = 80;
export const SCORE_STAT_MEDIUM_THRESHOLD = 65;
export const BENCHMARK_DELTA_THRESHOLD = 2;

export type ScoreStatLevel = 'high' | 'medium' | 'low';
export type BenchmarkDeltaVariant = 'up' | 'down' | 'flat';

export type ScoreStatColors = {
  color: string;
  barColor: string;
};

export type ScoreStatThresholds = {
  high: number;
  medium: number;
};

export const DEFAULT_SCORE_STAT_THRESHOLDS: ScoreStatThresholds = {
  high: SCORE_STAT_HIGH_THRESHOLD,
  medium: SCORE_STAT_MEDIUM_THRESHOLD,
};

export const getScoreStatLevel = (
  score: number,
  thresholds: ScoreStatThresholds = DEFAULT_SCORE_STAT_THRESHOLDS,
): ScoreStatLevel => {
  if (score >= thresholds.high) {
    return 'high';
  }
  if (score >= thresholds.medium) {
    return 'medium';
  }
  return 'low';
};

export const getScoreStatColors = (
  score: number,
  thresholds: ScoreStatThresholds = DEFAULT_SCORE_STAT_THRESHOLDS,
): ScoreStatColors => {
  const level = getScoreStatLevel(score, thresholds);
  const {color, strokeColor} = scorePill[level];

  return {
    color,
    barColor: strokeColor,
  };
};

export const getBenchmarkDelta = (score: number | null, reference: number | null): number | null => {
  if (score === null || reference === null) {
    return null;
  }

  return score - reference;
};

export const getBenchmarkDeltaVariant = (
  delta: number | null,
  threshold: number = BENCHMARK_DELTA_THRESHOLD,
): BenchmarkDeltaVariant | null => {
  if (delta === null) {
    return null;
  }

  if (Math.abs(delta) < threshold) {
    return 'flat';
  }

  return delta > 0 ? 'up' : 'down';
};
